import { images } from "../../assets/images";


export const createQuestionsTools = [
{
  id: "quick-sheets",
  title: "Quick Sheets",
  description: "Ready-to-print drill sheets",
  iconSrc: images.createQuestions.cardIcons[0],
  href: "#quick-sheets"
},
{
  id: "concept-questions",
  title: "Concept -> Questions",
  description: "Convert text to MCQ sets",
  iconSrc: images.createQuestions.cardIcons[1],
  href: "#concept-questions"
},
{
  id: "question-variations",
  title: "Question Variations",
  description: "Prevent copying with\nvariants",
  iconSrc: images.createQuestions.cardIcons[2],
  href: "#question-variations"
},
{
  id: "quick-assessment",
  title: "Quick Assessment",
  description: "10-minute check-for-\nunderstanding",
  iconSrc: images.createQuestions.cardIcons[3],
  href: "#quick-assessment"
}];